import { atom } from "recoil";

export const videoPopupState = atom({
  key: "isVideoPopup",
  default: true,
});
